export default __webpack_public_path__ + "static/media/icon-kosten-senken-wei.bfd4a95e.svg";